import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ProtectWidget from '../components/ProtectWidget';
const ProtectComponent = () => {
    return (_jsx("div", { className: "protect-component", children: _jsx(ProtectWidget, { containerId: "protect-widget-container" }) }));
};
const ProtectPage = () => {
    return (_jsx("div", { className: "page protect-page", children: _jsx(ProtectComponent, {}) }));
};
export default ProtectPage;
